import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "datatableTr" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { style: {"margin-left":"5px"} }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = ["value", "onUpdate:modelValue"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = ["onUpdate:modelValue"]

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from "axios";
import { computed, onMounted, ref } from "vue";
import { mdiMagnify } from "@mdi/js";

interface SisulItem {
  sisul_name: string;
  sisul_code: string;
  sisul_boss_name: string;
  sisul_since: string;
  sisul_jungwon: string;
  sisul_addr: string;
  sisul_role: number;
  sisul_status: string;
  sisul_wage_in: string;
  sisul_wage_out: string;
  sisul_id: string;
  sisul_biz_gubun: string;
}

interface HeaderItem {
  title: string;
  key: string;
  align: string;
  sortable: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminIndexPage',
  setup(__props) {

const store = useStore();
const router = useRouter();

const sisulList = ref<SisulItem[]>([]);
const search = ref("");
const headersArr = ref<HeaderItem[]>([
  { title: "No.", key: "index", align: "center", sortable: false },
  { title: "기관명", key: "sisul_name", align: "center", sortable: true },
  { title: "대표자", key: "sisul_boss_name", align: "center", sortable: true },
  { title: "설립일", key: "sisul_since", align: "center", sortable: true },
  { title: "수급자", key: "sisul_jungwon", align: "center", sortable: true },
  { title: "주소", key: "sisul_addr", align: "center", sortable: true },
  { title: "인증", key: "sisul_role", align: "center", sortable: true },
  { title: "상태", key: "sisul_status", align: "center", sortable: true },
  { title: "서비스시작일", key: "sisul_wage_in", align: "center", sortable: true },
  { title: "서비스탈퇴일", key: "sisul_wage_out", align: "center", sortable: true },
]);
const SsRoleOptions = ref([
  { label: "미인증", value: 0 },
  { label: "인증", value: 3 },
]);
const SsStatusOptions = ref([
  { label: "탈퇴", value: "0" },
  { label: "정상", value: "1" },
  { label: "휴직", value: "2" },
  { label: "경고", value: "3" },
]);
const filteredItems = computed(() => {
  // 검색어가 비어 있으면 전체 리스트 반환
  if (!search.value) {
    return sisulList.value;
  }
  return sisulList.value.filter(
    (item) =>
      item.sisul_name &&
      item.sisul_name.toLowerCase().includes(search.value.toLowerCase())
  );
});
const selectSisul = (item: SisulItem) => {
  const sisul = `${item.sisul_name}(${item.sisul_code})`;
  const bizGubun = item.sisul_biz_gubun;
  let goto = "CompBasicInfo";
  
  store.commit("setAdminSisul", sisul);
  store.commit("setAdminSisulCode", item.sisul_code);
  store.commit("setAdminSisulName", item.sisul_name);
  store.commit("setAdminSisulId", item.sisul_id);
  store.commit("setAdminBizGubun", bizGubun);
  
  router.push(`/${goto}`).then(() => {
    location.reload(); // 라우터 푸시 후에 페이지를 리로드
  });
};
const getInChargeSisul = async () => {
  try {
    const response = await axios.get(`/api/getInChargeSisul/`);
    const responseData = response.data;
    if (responseData) {
      sisulList.value = responseData;
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  }
};
onMounted(async () => {
  await getInChargeSisul();
});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (sisulList.value.length !== 0)
    ? (_openBlock(), _createBlock(_component_v_data_table, {
        key: 0,
        "no-data-text": "데이터가 존재하지 않습니다.",
        "fixed-header": "",
        density: "compact",
        scrollable: "",
        headers: headersArr.value,
        items: filteredItems.value,
        search: search.value,
        "item-value": "name",
        class: "fontNotoSans400",
        style: {"height":"calc(100vh - 64px)","overflow-y":"hidden","position":"relative"},
        "items-per-page": 50,
        "items-per-page-options": [
      { value: 50, title: '50' },
      { value: 100, title: '100' },
      { value: 200, title: '200' },
      // { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
    ]
      }, {
        top: _withCtx(() => [
          _createVNode(_component_v_toolbar, { flat: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, { class: "fontNotoSans700" }, {
                default: _withCtx(() => [
                  _createTextVNode("🏢 고객관리")
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider, {
                class: "mx-4",
                inset: "",
                vertical: ""
              }),
              _createVNode(_component_v_text_field, {
                class: "inoutSearchInput",
                style: {"background-color":"#fff","max-width":"200px","width":"auto","min-width":"70px","margin":"0 20px 0 0"},
                modelValue: search.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                color: "#0f7545",
                label: "고객기관, 주소 검색",
                "single-line": "",
                clearable: "",
                "append-inner-icon": _unref(mdiMagnify),
                flat: "",
                "hide-details": "auto",
                variant: "outlined",
                density: "compact"
              }, null, 8, ["modelValue", "append-inner-icon"])
            ]),
            _: 1
          })
        ]),
        item: _withCtx(({ item, index }) => [
          _createElementVNode("tr", _hoisted_1, [
            _createElementVNode("td", _hoisted_2, _toDisplayString(index + 1), 1),
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_v_chip, {
                onClick: ($event: any) => (selectSisul(item)),
                variant: "text",
                label: "",
                class: "ma-2",
                color: "black"
              }, {
                default: _withCtx(() => [
                  (item.sisul_biz_gubun === '주간보호')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        class: "text-right",
                        color: "orange ",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 주간 ")
                        ]),
                        _: 1
                      }))
                    : (item.sisul_biz_gubun === '요양시설')
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          class: "text-right",
                          color: "blue",
                          label: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 요양 ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_chip, {
                          key: 2,
                          class: "text-right",
                          color: "blue",
                          label: ""
                        })),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(item.sisul_name || ""), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createTextVNode(_toDisplayString(item.sisul_boss_name) + " / " + _toDisplayString(item.sisul_boss_phone), 1),
              _hoisted_6,
              _createTextVNode(_toDisplayString(item.sisul_boss_email), 1)
            ]),
            _createElementVNode("td", _hoisted_7, _toDisplayString(item.sisul_since), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(item.sisul_hyunwon) + "/" + _toDisplayString(item.sisul_jungwon), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(item.sisul_small_addr), 1),
            _createElementVNode("td", _hoisted_10, [
              (!item.editing)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.sisul_role === 0)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "red-accent-4 "
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.role_name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (item.sisul_role === 3)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            color: "blue-accent-4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.role_name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                  ], 64))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": ($event: any) => ((item.sisul_role) = $event),
                    style: {"outline":"auto","padding":"3px 20px 3px 20px"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SsRoleOptions.value, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.label), 9, _hoisted_12))
                    }), 128))
                  ], 8, _hoisted_11)), [
                    [_vModelSelect, item.sisul_role]
                  ])
            ]),
            _createElementVNode("td", _hoisted_13, [
              (!item.editing)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.sisul_status === '0')
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "black"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.status_name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (item.sisul_status === '1')
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            color: "green-darken-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.status_name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (item.sisul_status === '2')
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 2,
                              color: "orange-accent-4"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.status_name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (item.sisul_status === '3')
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 3,
                                color: "yellow-darken-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.status_name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                  ], 64))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": ($event: any) => ((item.sisul_status) = $event),
                    style: {"outline":"auto","padding":"3px 20px 3px 20px"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(SsStatusOptions.value, (status) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: status.value,
                        value: status.value
                      }, _toDisplayString(status.label), 9, _hoisted_15))
                    }), 128))
                  ], 8, _hoisted_14)), [
                    [_vModelSelect, item.sisul_status]
                  ])
            ]),
            _createElementVNode("td", _hoisted_16, [
              (!item.editing)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.sisul_wage_in)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "임금: " + _toDisplayString(item.sisul_wage_in), 1))
                      : _createCommentVNode("", true),
                    (item.sisul_fna_in)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, "회계: " + _toDisplayString(item.sisul_fna_in), 1))
                      : _createCommentVNode("", true),
                    (item.sisul_meal_in)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, "급식: " + _toDisplayString(item.sisul_meal_in), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" 임금: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      value: item.sisul_wage_in,
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_wage_in) = $event)
                    }, null, 8, _hoisted_20), [
                      [_vModelText, item.sisul_wage_in]
                    ]),
                    _hoisted_21,
                    _createTextVNode(" 회계: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_fna_in) = $event)
                    }, null, 8, _hoisted_22), [
                      [_vModelText, item.sisul_fna_in]
                    ]),
                    _hoisted_23,
                    _createTextVNode(" 급식: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_meal_in) = $event)
                    }, null, 8, _hoisted_24), [
                      [_vModelText, item.sisul_meal_in]
                    ])
                  ], 64))
            ]),
            _createElementVNode("td", _hoisted_25, [
              (!item.editing)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (item.sisul_wage_out)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, "임금: " + _toDisplayString(item.sisul_wage_out), 1))
                      : _createCommentVNode("", true),
                    (item.sisul_fna_out)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, "회계: " + _toDisplayString(item.sisul_fna_out), 1))
                      : _createCommentVNode("", true),
                    (item.sisul_meal_out)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "급식: " + _toDisplayString(item.sisul_meal_out), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" 임금: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_wage_out) = $event)
                    }, null, 8, _hoisted_29), [
                      [_vModelText, item.sisul_wage_out]
                    ]),
                    _hoisted_30,
                    _createTextVNode(" 회계: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_fna_out) = $event)
                    }, null, 8, _hoisted_31), [
                      [_vModelText, item.sisul_fna_out]
                    ]),
                    _hoisted_32,
                    _createTextVNode(" 급식: "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      style: {"border":"1px solid #000","padding":"1px 0 1px 3px","border-radius":"3px"},
                      "onUpdate:modelValue": ($event: any) => ((item.sisul_meal_out) = $event)
                    }, null, 8, _hoisted_33), [
                      [_vModelText, item.sisul_meal_out]
                    ])
                  ], 64))
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "items", "search", "items-per-page-options"]))
    : _createCommentVNode("", true)
}
}

})